module.exports = __webpack_public_path__ + "assets/b3e341cf774ea8f4b47997904fb170f3.mp3";